// useFormGuardStore.ts
import { create } from 'zustand';

type FormGuardState = {
  ignoreGuard: boolean;
  setIgnoreGuard: (v: boolean) => void;
  resetGuard: () => void;
};

export const useFormGuardStore = create<FormGuardState>(set => ({
  ignoreGuard: false,
  setIgnoreGuard: v => set({ ignoreGuard: v }),
  resetGuard: () => set({ ignoreGuard: false }),
}));
